import { Link } from "react-router-dom";
import { ArrowLeft, PenLine, ShieldCheck } from "lucide-react";
import { LOGO_URL } from "@/lib/api";
import { useMember } from "@/context/MemberContext";
import { MemberAuthPanel } from "@/components/member/MemberAuthPanel";
import { LetterGenerator } from "@/components/letter/LetterGenerator";
import { Footer } from "@/components/Footer";

export default function WriteLetter() {
  const { member, loading } = useMember();
  return (
    <div className="min-h-screen bg-[#F3EFE4]" data-testid="write-letter-page">
      <header className="bg-[#121E2B] text-[#FDFBF7] relative grain overflow-hidden">
        <div className="relative max-w-6xl mx-auto px-5 sm:px-8 py-8 sm:py-12">
          <div className="flex items-center justify-between mb-8">
            <Link to="/bills" data-testid="write-letter-back-link" className="inline-flex items-center gap-1.5 text-xs font-type uppercase tracking-widest text-[#8FA58A] hover:text-[#E2705A]"><ArrowLeft className="w-3.5 h-3.5" /> Bill Board</Link>
            <Link to="/"><img src={LOGO_URL} alt="R.O.A.N" className="h-12 object-contain" /></Link>
          </div>
          <p className="font-type text-xs uppercase tracking-[0.3em] text-[#8FA58A]">F.E.R.M letter · you write it, you send it</p>
          <h1 className="font-type font-bold text-4xl sm:text-5xl lg:text-6xl mt-1">Write to your federal member</h1>
          <p className="mt-4 max-w-2xl text-sm sm:text-base text-[#FDFBF7]/80 leading-relaxed">
            A filled-in letter to your sitting member or a candidate — your name, your division, their electorate office. Local matters can be added once approved by your F.E.R.M committee. Send it from your own email — the R.O.A.N Initiative never sends anything on your behalf.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 text-xs text-[#FDFBF7]/60"><ShieldCheck className="w-4 h-4 text-[#8FA58A]" /> Instrument beats inference — enforced in the form.</p>
        </div>
        <div className="h-2 bg-[#E2705A]" />
      </header>

      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-10">
        {loading ? null : member ? (
          <LetterGenerator />
        ) : (
          <div className="grid md:grid-cols-[1fr_minmax(300px,380px)] gap-8 items-start" data-testid="write-letter-signin">
            <div className="space-y-4">
              <h2 className="font-type font-bold text-base md:text-lg text-[#1B2A41] uppercase tracking-wider">F.E.R.Ms only — sign in or join first</h2>
              <p className="text-sm text-[#5C6A79] leading-relaxed">The letter is filled from your registration: your name, postcode, division and the federal member for it. If you're not a F.E.R.M yet, joining takes a minute — name, email, postcode — and you'll land straight back here.</p>
              <Link to="/?next=/write#join" data-testid="write-letter-join-link" className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-[#E2705A] hover:bg-[#D35D46] text-white text-xs font-type font-bold uppercase tracking-wider"><PenLine className="w-4 h-4" /> Join as a F.E.R.M</Link>
            </div>
            <div className="rounded-2xl bg-white border border-[#1B2A41]/10 shadow-sm p-5">
              <p className="font-type text-[11px] uppercase tracking-[0.3em] text-[#5A7355] mb-3">Already a F.E.R.M?</p>
              <MemberAuthPanel />
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
